import {Component} from 'react';
import {MontantInput} from './montant-input'
class RevenusImposables extends Component {

	constructor(props){
		super(props);
		this.state = {
			demandeur : this.props.demandeur,
		
			
		};
		if (this.props.conjoint){
			this.state.conjoint = this.props.conjoint;
		}
		if (this.props.individus){
			Object.keys(this.props.individus).forEach((individu)=>{
				this.state[individu] = this.props.individus[individu]; 
			})
		}
		this.state.listeIndividu = Object.keys(this.state);

		this.state.revenus = {
	      'salaire_imposable':{ label: 'Revenus d’activité connus', value: 0 },
	      'chomage_imposable':{ label: 'Autres revenus imposables (préretraite, chômage) ', value: 0 },
	      'retraite_imposable':{ label: 'Pensions, retraites, rentes ', value: 0 },
	      'frais_reels':{ label: 'Frais réels déductibles', value: 0 },
	      'pensions_alimentaires_percues':{ label: 'Pensions alimentaires reçues', value: 0 },
	      'pensions_alimentaires_versees_individu':{label: 'Pensions alimentaires versées', value: 0 },
	      'revenus_locatifs':{ label: 'Revenus fonciers nets', value: 0 }
	    };
	    const currentYear = new Date().getFullYear();
	    [this.anneeN2 , this.anneeN1] = [currentYear-2 , currentYear-1];

	    this.captureRevenu = this.captureRevenu.bind(this);

	}

	captureRevenu = (montant , revenuName,individu) =>{
		var declarationMontant = {};
		
		for ( let x=1; x<=12 ;x++){
			let dateString  =  `${this.anneeN2}-${('0'+x).slice(-2)}`;
			declarationMontant[dateString] = montant/12 ;
		}

		this.setState( (state)=>{
			if ( typeof state[individu].ressources === 'undefined')
				state[individu].ressources = {};
			state[individu].ressources[revenuName] = declarationMontant ;
			return state;
		});
	}

	validateData = ()=>{

		let data = {'individus':{}};
		this.state.listeIndividu.forEach((individu)=>{
			const dataIndividu = this.state[individu];
			if ( ['conjoint','demandeur'].includes('individu')){
				data[individu] = dataIndividu;
			}else {
				data.individus[individu] = dataIndividu;
			}
		})

		this.props.validateStep(data ,true);//updateOnly
		this.props.returnToResult();
	}

	render() {
		
		return <div className="step-inner-container">
			<h4>Les revenus imposables du foyer en {this.anneeN2}</h4>
			<small>Ces informations se trouvent sur votre avis d’imposition {this.anneeN1} sur les revenus {this.anneeN2}</small>
			
			<div className="revenus-imposable">
				{
					this.state.listeIndividu.map((individu)=>{
						return <>
							<hr/>
							<h3>
								{(individu==='demandeur') ? "Vos ressources personnelles N-2":''}
								{(individu==='conjoint') ? "Les ressources personnelles N-2 de votre conjoint.e":''}
							</h3>
							{Object.keys(this.state.revenus).map( (revenu)=>(
								<div className="revenu-input">
									<MontantInput name={revenu}
										modelName={revenu}
										handler ={(montant,modelName)=>(this.captureRevenu(montant,modelName,individu))}
										

									>{this.state.revenus[revenu].label}</MontantInput>
								</div>
							))}
						</>
					})

				}
			</div>

			<button onClick={this.props.returnToResult}>Enregistrer</button>
		</div>
	}
}

export default RevenusImposables;